import React from "react";

const SaleRateRabiCropsVegetables = () => {
  return (
    <div className="container my-3">
      <div className="abouts">
        <h5>Sale Rate of Rabi Seeds - Vegetables</h5>
      </div>

      <div
        className="about-box p-4 rounded shadow-lg "
        style={{ textAlign: "justify" }}
      >
        <div className="row mb-1 justify-content-between">
          <div className="col-lg-12 mb-1">
            <h6>Our seed remains available easily at:</h6>

            <ol>
              <li>HSDC sale counters.</li>
              <li>
                Farmers&#39; Service Centres of Haryana Agro Industries
                Corporation.
              </li>
              <li>Mini Banks.</li>
              <li>Co-op. Societies of HAFED.</li>
              <li>Farmers&#39; Service Centres of HLRDC.</li>
            </ol>

            <div className="table-responsive">
              <table className="table table-striped table-bordered">
                <thead>
                  <tr>
                    <th colspan="7">Sale Rate for Rabi 2023-24</th>
                  </tr>
                  <tr>
                    <th>Sr. No</th>
                    <th> Crop</th>
                    <th>Variety</th>
                    <th>Packing Size</th>
                    <th>Sale Rate </th>
                    <th>Subsidy</th>
                    <th>Net sale rate after rounding off per packing Size</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>1</td>
                    <td>Coriander</td>
                    <td>WCO-01</td>
                    <td>0.5kg</td>
                    <td>358</td>
                    <td>0</td>
                    <td>358</td>
                  </tr>
                  <tr>
                    <td>2</td>
                    <td>Spinach</td>
                    <td>WSP-01</td>
                    <td>0.5kg</td>
                    <td>248</td>
                    <td>0</td>
                    <td>248</td>
                  </tr>
                  <tr>
                    <td>3</td>
                    <td>Mustard</td>
                    <td>19S21</td>
                    <td>1kg</td>
                    <td>490</td>
                    <td>0</td>
                    <td>490</td>
                  </tr>
                  <tr>
                    <td>4</td>
                    <td>TOMATO</td>
                    <td>GURU</td>
                    <td>10 gm</td>
                    <td>230</td>
                    <td>0</td>
                    <td>230</td>
                  </tr>
                  <tr>
                    <td>5</td>
                    <td>TOMATO</td>
                    <td>SATYA</td>
                    <td>10gm</td>
                    <td>398</td>
                    <td>0</td>
                    <td>398</td>
                  </tr>
                  <tr>
                    <td>6</td>
                    <td>BHINDI</td>
                    <td>SHIVANI</td>
                    <td>500gm</td>
                    <td>1150</td>
                    <td>0</td>
                    <td>1150</td>
                  </tr>
                  <tr>
                    <td>7</td>
                    <td>ONION</td>
                    <td>RED BEAUTY</td>
                    <td>500gm</td>
                    <td>732</td>
                    <td>0</td>
                    <td>732</td>
                  </tr>
                  <tr>
                    <td>8</td>
                    <td>ONION</td>
                    <td>AK 47</td>
                    <td>500gm</td>
                    <td>1672</td>
                    <td>0</td>
                    <td>1672</td>
                  </tr>
                  <tr>
                    <td>9</td>
                    <td>CORIANDER</td>
                    <td>DIVYANK</td>
                    <td>500gm</td>
                    <td>523</td>
                    <td>0</td>
                    <td>523</td>
                  </tr>
                  <tr>
                    <td>10</td>
                    <td>PEA</td>
                    <td>DASHAK</td>
                    <td>5kg</td>
                    <td>2134</td>
                    <td>0</td>
                    <td>2134</td>
                  </tr>
                  <tr>
                    <td>11</td>
                    <td>KARELA</td>
                    <td>DEV</td>
                    <td>50gm</td>
                    <td>418</td>
                    <td>0</td>
                    <td>418</td>
                  </tr>
                  <tr>
                    <td>12</td>
                    <td>BRINJAL </td>
                    <td>KAVIYA</td>
                    <td>10gm</td>
                    <td>157</td>
                    <td>0</td>
                    <td>157</td>
                  </tr>
                  <tr>
                    <td>13</td>
                    <td>WATERMELON</td>
                    <td>MAGNET</td>
                    <td>50gm</td>
                    <td>523</td>
                    <td>0</td>
                    <td>523</td>
                  </tr>
                  <tr>
                    <td>14</td>
                    <td>RIDGE GOURD</td>
                    <td>DRITHI</td>
                    <td>50gm</td>
                    <td>210</td>
                    <td>0</td>
                    <td>210</td>
                  </tr>
                  <tr>
                    <td>15</td>
                    <td>BOTTEL GOURD</td>
                    <td>GREEN GOLD</td>
                    <td>50gm</td>
                    <td>210</td>
                    <td>0</td>
                    <td>210</td>
                  </tr>
                  <tr>
                    <td>16</td>
                    <td>CARROT </td>
                    <td>RED LADY</td>
                    <td>500gm</td>
                    <td>940</td>
                    <td>0</td>
                    <td>940</td>
                  </tr>
                  <tr>
                    <td>17</td>
                    <td>RADISH</td>
                    <td>HIMANI</td>
                    <td>500gm</td>
                    <td>836</td>
                    <td>0</td>
                    <td>836</td>
                  </tr>
                  <tr>
                    <td>18</td>
                    <td>MUSTARD</td>
                    <td>MIG-21</td>
                    <td>1kg</td>
                    <td>630</td>
                    <td>0</td>
                    <td>630</td>
                  </tr>
                  <tr>
                    <td>19</td>
                    <td>MUSTARD</td>
                    <td>35A46</td>
                    <td>1kg</td>
                    <td>835</td>
                    <td>0</td>
                    <td>835</td>
                  </tr>
                  <tr>
                    <td>20</td>
                    <td>MUSTARD</td>
                    <td>45A86</td>
                    <td>1kg</td>
                    <td>365</td>
                    <td>0</td>
                    <td>365</td>
                  </tr>
                  <tr>
                    <td>21</td>
                    <td>Kitchen Garden kit</td>
                    <td>Any Four seasonal crop seeds in 1 Pkt</td>
                    <td>PKT</td>
                    <td>60</td>
                    <td>0</td>
                    <td>60</td>
                  </tr>
                  <tr>
                    <td>22</td>
                    <td>Cauliflower</td>
                    <td>Khushi 70</td>
                    <td>10gm</td>
                    <td>505</td>
                    <td>0</td>
                    <td>505</td>
                  </tr>
                  <tr>
                    <td>23</td>
                    <td>Cauliflower</td>
                    <td>White Queen</td>
                    <td>10gm</td>
                    <td>505</td>
                    <td>0</td>
                    <td>505</td>
                  </tr>
                  <tr>
                    <td>24</td>
                    <td>Cauliflower</td>
                    <td>Early Basant</td>
                    <td>10gm</td>
                    <td>505</td>
                    <td>0</td>
                    <td>505</td>
                  </tr>
                  <tr>
                    <td>25</td>
                    <td>Cabbage</td>
                    <td>Tej IMP</td>
                    <td>10gm</td>
                    <td>340</td>
                    <td>0</td>
                    <td>340</td>
                  </tr>
                  <tr>
                    <td>26</td>
                    <td>Cabbage</td>
                    <td>Tej</td>
                    <td>10gm</td>
                    <td>270</td>
                    <td>0</td>
                    <td>270</td>
                  </tr>
                  <tr>
                    <td>27</td>
                    <td>Water Melon</td>
                    <td>Taj</td>
                    <td>10gm</td>
                    <td>110</td>
                    <td>0</td>
                    <td>110</td>
                  </tr>
                  <tr>
                    <td>28</td>
                    <td>Water Melon</td>
                    <td>Black King</td>
                    <td>10gm</td>
                    <td>135</td>
                    <td>0</td>
                    <td>135</td>
                  </tr>
                  <tr>
                    <td>29</td>
                    <td>Water Melon</td>
                    <td>Black Baby</td>
                    <td>10gm</td>
                    <td>360</td>
                    <td>0</td>
                    <td>360</td>
                  </tr>
                  <tr>
                    <td>30</td>
                    <td>Radish</td>
                    <td>Farrata 31</td>
                    <td>50gm</td>
                    <td>75</td>
                    <td>0</td>
                    <td>75</td>
                  </tr>
                  <tr>
                    <td>31</td>
                    <td>Radish</td>
                    <td>SKS 34</td>
                    <td>50gm</td>
                    <td>90</td>
                    <td>0</td>
                    <td>90</td>
                  </tr>
                  <tr>
                    <td>32</td>
                    <td>Radish</td>
                    <td>X 35</td>
                    <td>50gm</td>
                    <td>110</td>
                    <td>0</td>
                    <td>110</td>
                  </tr>
                  <tr>
                    <td>33</td>
                    <td>Radish</td>
                    <td>White Snow</td>
                    <td>50gm</td>
                    <td>80</td>
                    <td>0</td>
                    <td>80</td>
                  </tr>
                  <tr>
                    <td>34</td>
                    <td>Squash</td>
                    <td>Heera</td>
                    <td>10gm</td>
                    <td>90</td>
                    <td>0</td>
                    <td>90</td>
                  </tr>
                  <tr>
                    <td>35</td>
                    <td>Bitter gourd</td>
                    <td>Akshaya</td>
                    <td>10gm</td>
                    <td>95</td>
                    <td>0</td>
                    <td>95</td>
                  </tr>
                  <tr>
                    <td>36</td>
                    <td>Bitter gourd</td>
                    <td>Pratap</td>
                    <td>10gm</td>
                    <td>95</td>
                    <td>0</td>
                    <td>95</td>
                  </tr>
                  <tr>
                    <td>37</td>
                    <td>Bottle gourd</td>
                    <td>Golu</td>
                    <td>10gm</td>
                    <td>42</td>
                    <td>0</td>
                    <td>42</td>
                  </tr>
                  <tr>
                    <td>38</td>
                    <td>Bottle gourd</td>
                    <td>Kranti</td>
                    <td>10gm</td>
                    <td>42</td>
                    <td>0</td>
                    <td>42</td>
                  </tr>
                  <tr>
                    <td>39</td>
                    <td>Bottle gourd</td>
                    <td>Naveen 55</td>
                    <td>10gm</td>
                    <td>42</td>
                    <td>0</td>
                    <td>42</td>
                  </tr>
                  <tr>
                    <td>40</td>
                    <td>Capsicum</td>
                    <td>Avtar</td>
                    <td>10gm</td>
                    <td>905</td>
                    <td>0</td>
                    <td>905</td>
                  </tr>
                  <tr>
                    <td>41</td>
                    <td>Capsicum</td>
                    <td>SKS-203</td>
                    <td>10gm</td>
                    <td>1025</td>
                    <td>0</td>
                    <td>1025</td>
                  </tr>
                  <tr>
                    <td>42</td>
                    <td>Chilli</td>
                    <td>Mistika</td>
                    <td>10gm</td>
                    <td>387</td>
                    <td>0</td>
                    <td>387</td>
                  </tr>
                  <tr>
                    <td>43</td>
                    <td>Cucumber</td>
                    <td>Dammu</td>
                    <td>10gm</td>
                    <td>215</td>
                    <td>0</td>
                    <td>215</td>
                  </tr>
                  <tr>
                    <td>44</td>
                    <td>Cucumber</td>
                    <td>Himanshi</td>
                    <td>10gm</td>
                    <td>215</td>
                    <td>0</td>
                    <td>215</td>
                  </tr>
                  <tr>
                    <td>45</td>
                    <td>Cucumber</td>
                    <td>Kanti</td>
                    <td>10gm</td>
                    <td>215</td>
                    <td>0</td>
                    <td>215</td>
                  </tr>
                  <tr>
                    <td>46</td>
                    <td>Cucumber</td>
                    <td>Manish</td>
                    <td>10gm</td>
                    <td>183</td>
                    <td>0</td>
                    <td>183</td>
                  </tr>
                  <tr>
                    <td>47</td>
                    <td>Pumpkin</td>
                    <td>Mahima</td>
                    <td>10gm</td>
                    <td>63</td>
                    <td>0</td>
                    <td>63</td>
                  </tr>
                  <tr>
                    <td>48</td>
                    <td>Pumpkin</td>
                    <td>Samarat</td>
                    <td>10gm</td>
                    <td>58</td>
                    <td>0</td>
                    <td>58</td>
                  </tr>
                  <tr>
                    <td>49</td>
                    <td>Pumpkin</td>
                    <td>Siddh</td>
                    <td>10gm</td>
                    <td>63</td>
                    <td>0</td>
                    <td>63</td>
                  </tr>
                  <tr>
                    <td>50</td>
                    <td>Ridge gourd</td>
                    <td>Aarti</td>
                    <td>10gm</td>
                    <td>52</td>
                    <td>0</td>
                    <td>52</td>
                  </tr>
                  <tr>
                    <td>51</td>
                    <td>Sponge gourd</td>
                    <td>Chetan</td>
                    <td>10gm</td>
                    <td>42</td>
                    <td>0</td>
                    <td>42</td>
                  </tr>
                  <tr>
                    <td>52</td>
                    <td>Tomato</td>
                    <td>Varsha</td>
                    <td>10gm</td>
                    <td>360</td>
                    <td>0</td>
                    <td>360</td>
                  </tr>
                  <tr>
                    <td>53</td>
                    <td>Tomato</td>
                    <td>Ritu</td>
                    <td>10gm</td>
                    <td>360</td>
                    <td>0</td>
                    <td>360</td>
                  </tr>
                  <tr>
                    <td>54</td>
                    <td>Tomato</td>
                    <td>Rudraksh</td>
                    <td>10gm</td>
                    <td>627</td>
                    <td>0</td>
                    <td>627</td>
                  </tr>
                  <tr>
                    <td>55</td>
                    <td>Tomato</td>
                    <td>SKS 3505</td>
                    <td>10gm</td>
                    <td>386</td>
                    <td>0</td>
                    <td>386</td>
                  </tr>
                  <tr>
                    <td>56</td>
                    <td>Tomato</td>
                    <td>Upahar</td>
                    <td>10gm</td>
                    <td>480</td>
                    <td>0</td>
                    <td>480</td>
                  </tr>
                  <tr>
                    <td>57</td>
                    <td>Brinjal</td>
                    <td>Navaneet</td>
                    <td>10gm</td>
                    <td>105</td>
                    <td>0</td>
                    <td>105</td>
                  </tr>
                  <tr>
                    <td>58</td>
                    <td>Beet Root</td>
                    <td>SKS Red Ratan</td>
                    <td>10gm</td>
                    <td>67</td>
                    <td>0</td>
                    <td>67</td>
                  </tr>
                  <tr>
                    <td>59</td>
                    <td>Cauliflower</td>
                    <td>Khushi 70</td>
                    <td>1gm</td>
                    <td>42</td>
                    <td>0</td>
                    <td>42</td>
                  </tr>
                  <tr>
                    <td>60</td>
                    <td>Cauliflower</td>
                    <td>White Queen</td>
                    <td>1gm</td>
                    <td>42</td>
                    <td>0</td>
                    <td>42</td>
                  </tr>
                  <tr>
                    <td>61</td>
                    <td>Cauliflower</td>
                    <td>Early Basant</td>
                    <td>1gm</td>
                    <td>42</td>
                    <td>0</td>
                    <td>42</td>
                  </tr>
                  <tr>
                    <td>62</td>
                    <td>Cabbage</td>
                    <td>Tej IMP</td>
                    <td>1gm</td>
                    <td>42</td>
                    <td>0</td>
                    <td>42</td>
                  </tr>
                  <tr>
                    <td>63</td>
                    <td>Cabbage</td>
                    <td>Tej</td>
                    <td>1gm</td>
                    <td>42</td>
                    <td>0</td>
                    <td>42</td>
                  </tr>
                  <tr>
                    <td>64</td>
                    <td>Water Melon</td>
                    <td>Taj</td>
                    <td>5gm</td>
                    <td>42</td>
                    <td>0</td>
                    <td>42</td>
                  </tr>
                  <tr>
                    <td>65</td>
                    <td>Water Melon</td>
                    <td>Black King</td>
                    <td>5gm</td>
                    <td>42</td>
                    <td>0</td>
                    <td>42</td>
                  </tr>
                  <tr>
                    <td>66</td>
                    <td>Water Melon</td>
                    <td>Black Baby</td>
                    <td>5gm</td>
                    <td>42</td>
                    <td>0</td>
                    <td>42</td>
                  </tr>
                  <tr>
                    <td>67</td>
                    <td>Radish</td>
                    <td>Farrata 31</td>
                    <td>25gm</td>
                    <td>42</td>
                    <td>0</td>
                    <td>42</td>
                  </tr>
                  <tr>
                    <td>68</td>
                    <td>Radish</td>
                    <td>SKS 34</td>
                    <td>25gm</td>
                    <td>42</td>
                    <td>0</td>
                    <td>42</td>
                  </tr>
                  <tr>
                    <td>69</td>
                    <td>Radish</td>
                    <td>X 35</td>
                    <td>25gm</td>
                    <td>42</td>
                    <td>0</td>
                    <td>42</td>
                  </tr>
                  <tr>
                    <td>70</td>
                    <td>Radish</td>
                    <td>White Snow</td>
                    <td>25gm</td>
                    <td>42</td>
                    <td>0</td>
                    <td>42</td>
                  </tr>
                  <tr>
                    <td>71</td>
                    <td>Squash</td>
                    <td>Heera</td>
                    <td>5gm</td>
                    <td>42</td>
                    <td>0</td>
                    <td>42</td>
                  </tr>
                  <tr>
                    <td>72</td>
                    <td>Okra</td>
                    <td>Jaya Research</td>
                    <td>50gm</td>
                    <td>42</td>
                    <td>0</td>
                    <td>42</td>
                  </tr>
                  <tr>
                    <td>73</td>
                    <td>Okra</td>
                    <td>SKS 4001</td>
                    <td>50gm</td>
                    <td>42</td>
                    <td>0</td>
                    <td>42</td>
                  </tr>
                  <tr>
                    <td>74</td>
                    <td>Okra</td>
                    <td>SKS 905</td>
                    <td>50gm</td>
                    <td>42</td>
                    <td>0</td>
                    <td>42</td>
                  </tr>
                  <tr>
                    <td>75</td>
                    <td>Bitter gourd</td>
                    <td>Akshaya</td>
                    <td>10gm</td>
                    <td>42</td>
                    <td>0</td>
                    <td>42</td>
                  </tr>
                  <tr>
                    <td>76</td>
                    <td>Bitter gourd</td>
                    <td>Pratap</td>
                    <td>10gm</td>
                    <td>42</td>
                    <td>0</td>
                    <td>42</td>
                  </tr>
                  <tr>
                    <td>77</td>
                    <td>Bitter gourd</td>
                    <td>Venu</td>
                    <td>10gm</td>
                    <td>42</td>
                    <td>0</td>
                    <td>42</td>
                  </tr>
                  <tr>
                    <td>78</td>
                    <td>Bottle gourd</td>
                    <td>Golu</td>
                    <td>10gm</td>
                    <td>42</td>
                    <td>0</td>
                    <td>42</td>
                  </tr>
                  <tr>
                    <td>79</td>
                    <td>Bottle gourd</td>
                    <td>Kranti</td>
                    <td>10gm</td>
                    <td>42</td>
                    <td>0</td>
                    <td>42</td>
                  </tr>
                  <tr>
                    <td>80</td>
                    <td>Bottle gourd</td>
                    <td>Naveen 55</td>
                    <td>10gm</td>
                    <td>42</td>
                    <td>0</td>
                    <td>42</td>
                  </tr>
                  <tr>
                    <td>81</td>
                    <td>Capsicum</td>
                    <td>Avtar</td>
                    <td>1000 seed</td>
                    <td>42</td>
                    <td>0</td>
                    <td>42</td>
                  </tr>
                  <tr>
                    <td>82</td>
                    <td>Capsicum</td>
                    <td>SKS-203</td>
                    <td>1000 seed</td>
                    <td>42</td>
                    <td>0</td>
                    <td>42</td>
                  </tr>
                  <tr>
                    <td>83</td>
                    <td>Chilli</td>
                    <td>Mistika</td>
                    <td>1gm</td>
                    <td>42</td>
                    <td>0</td>
                    <td>42</td>
                  </tr>
                  <tr>
                    <td>84</td>
                    <td>Cucumber</td>
                    <td>Dammu</td>
                    <td>10gm</td>
                    <td>42</td>
                    <td>0</td>
                    <td>42</td>
                  </tr>
                  <tr>
                    <td>85</td>
                    <td>Cucumber</td>
                    <td>Himanshi</td>
                    <td>10gm</td>
                    <td>42</td>
                    <td>0</td>
                    <td>42</td>
                  </tr>
                  <tr>
                    <td>86</td>
                    <td>Cucumber</td>
                    <td>Kanti</td>
                    <td>10gm</td>
                    <td>42</td>
                    <td>0</td>
                    <td>42</td>
                  </tr>
                  <tr>
                    <td>87</td>
                    <td>Cucumber</td>
                    <td>Manish</td>
                    <td>10gm</td>
                    <td>42</td>
                    <td>0</td>
                    <td>42</td>
                  </tr>
                  <tr>
                    <td>88</td>
                    <td>Pumpkin</td>
                    <td>Mahima</td>
                    <td>10gm</td>
                    <td>42</td>
                    <td>0</td>
                    <td>42</td>
                  </tr>
                  <tr>
                    <td>89</td>
                    <td>Pumpkin</td>
                    <td>Samarat</td>
                    <td>10gm</td>
                    <td>42</td>
                    <td>0</td>
                    <td>42</td>
                  </tr>
                  <tr>
                    <td>90</td>
                    <td>Pumpkin</td>
                    <td>Siddh</td>
                    <td>10gm</td>
                    <td>42</td>
                    <td>0</td>
                    <td>42</td>
                  </tr>
                  <tr>
                    <td>91</td>
                    <td>Ridge gourd</td>
                    <td>Aarti</td>
                    <td>10gm</td>
                    <td>42</td>
                    <td>0</td>
                    <td>42</td>
                  </tr>
                  <tr>
                    <td>92</td>
                    <td>Sponge gourd</td>
                    <td>Chetan</td>
                    <td>10gm</td>
                    <td>42</td>
                    <td>0</td>
                    <td>42</td>
                  </tr>
                  <tr>
                    <td>93</td>
                    <td>Tomato</td>
                    <td>Varsha</td>
                    <td>1gm</td>
                    <td>42</td>
                    <td>0</td>
                    <td>42</td>
                  </tr>
                  <tr>
                    <td>94</td>
                    <td>Tomato</td>
                    <td>Ritu</td>
                    <td>1gm</td>
                    <td>42</td>
                    <td>0</td>
                    <td>42</td>
                  </tr>
                  <tr>
                    <td>95</td>
                    <td>Tomato</td>
                    <td>Rudraksh</td>
                    <td>1gm</td>
                    <td>42</td>
                    <td>0</td>
                    <td>42</td>
                  </tr>
                  <tr>
                    <td>96</td>
                    <td>Tomato</td>
                    <td>SKS-3505</td>
                    <td>1gm</td>
                    <td>42</td>
                    <td>0</td>
                    <td>42</td>
                  </tr>
                  <tr>
                    <td>97</td>
                    <td>Tomato</td>
                    <td>Upahar</td>
                    <td>1gm</td>
                    <td>42</td>
                    <td>0</td>
                    <td>42</td>
                  </tr>
                  <tr>
                    <td>98</td>
                    <td>Brinjal</td>
                    <td>Navaneet</td>
                    <td>5gm</td>
                    <td>42</td>
                    <td>0</td>
                    <td>42</td>
                  </tr>
                  <tr>
                    <td>99</td>
                    <td>Beet root</td>
                    <td>SKS Red ratan</td>
                    <td>20gm</td>
                    <td>42</td>
                    <td>0</td>
                    <td>42</td>
                  </tr>
                  <tr>
                    <td>100</td>
                    <td>Tomato</td>
                    <td>2182</td>
                    <td>10gm</td>
                    <td>890</td>
                    <td>0</td>
                    <td>890</td>
                  </tr>
                  <tr>
                    <td>101</td>
                    <td>Tomato</td>
                    <td>BIO 90</td>
                    <td>10gm</td>
                    <td>290</td>
                    <td>0</td>
                    <td>290</td>
                  </tr>
                  <tr>
                    <td>102</td>
                    <td>Okra</td>
                    <td>501</td>
                    <td>250gm</td>
                    <td>890</td>
                    <td>0</td>
                    <td>890</td>
                  </tr>
                  <tr>
                    <td>103</td>
                    <td>Okra</td>
                    <td>401</td>
                    <td>250gm</td>
                    <td>725</td>
                    <td>0</td>
                    <td>725</td>
                  </tr>
                  <tr>
                    <td>104</td>
                    <td>Bottle gourd</td>
                    <td>Alok</td>
                    <td>50gm</td>
                    <td>217</td>
                    <td>0</td>
                    <td>217</td>
                  </tr>
                  <tr>
                    <td>105</td>
                    <td>Bitter gourd</td>
                    <td>Alankar</td>
                    <td>50gm</td>
                    <td>570</td>
                    <td>0</td>
                    <td>570</td>
                  </tr>
                  <tr>
                    <td>106</td>
                    <td>Sponge gourd</td>
                    <td>Nand</td>
                    <td>50gm</td>
                    <td>186</td>
                    <td>0</td>
                    <td>186</td>
                  </tr>
                  <tr>
                    <td>107</td>
                    <td>Brinjal</td>
                    <td>Fast</td>
                    <td>10gm</td>
                    <td>67</td>
                    <td>0</td>
                    <td>67</td>
                  </tr>
                  <tr>
                    <td>108</td>
                    <td>Watermelon</td>
                    <td>Rohit</td>
                    <td>50gm</td>
                    <td>1540</td>
                    <td>0</td>
                    <td>1540</td>
                  </tr>
                  <tr>
                    <td>109</td>
                    <td>Coriander</td>
                    <td>Swad</td>
                    <td>500gm</td>
                    <td>155</td>
                    <td>0</td>
                    <td>155</td>
                  </tr>
                  <tr>
                    <td>110</td>
                    <td>Cucumber</td>
                    <td>BCH-1</td>
                    <td>10gm</td>
                    <td>217</td>
                    <td>0</td>
                    <td>217</td>
                  </tr>
                  <tr>
                    <td>111</td>
                    <td>Radish</td>
                    <td>Himani</td>
                    <td>100gm</td>
                    <td>150</td>
                    <td>0</td>
                    <td>150</td>
                  </tr>
                  <tr>
                    <td>112</td>
                    <td>Carrot</td>
                    <td>Red star</td>
                    <td>250gm</td>
                    <td>155</td>
                    <td>0</td>
                    <td>155</td>
                  </tr>
                  <tr>
                    <td>113</td>
                    <td>Palak</td>
                    <td>Palak</td>
                    <td>500gm</td>
                    <td>77</td>
                    <td>0</td>
                    <td>77</td>
                  </tr>
                  <tr>
                    <td>114</td>
                    <td>Mustard</td>
                    <td>208</td>
                    <td>1 Kg</td>
                    <td>775</td>
                    <td>0</td>
                    <td>775</td>
                  </tr>
                  <tr>
                    <td>115</td>
                    <td>Methi</td>
                    <td>All Variety</td>
                    <td>2.5 Kg</td>
                    <td>300</td>
                    <td>150</td>
                    <td>150 per bag</td>
                  </tr>
                  <tr>
                    <td>116</td>
                    <td>Palak </td>
                    <td>All varieties</td>
                    <td>2.5 Kg</td>
                    <td>275</td>
                    <td>137.5</td>
                    <td>137.50 per bag or say 138</td>
                  </tr>
                  <tr>
                    <td>117</td>
                    <td>Corriander </td>
                    <td>All varieties</td>
                    <td>1.5 Kg</td>
                    <td>300</td>
                    <td>150</td>
                    <td>150 per bag</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SaleRateRabiCropsVegetables;
